<template>
	<div>
		<div class="form-section-base__block-outer">
			<div class="form-section-base__block-inner">
				<slot></slot>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="v.name.$model"
							:errorMessages="getValidationErrorText(v.name)"
							label="Наименование"
							outlined
							:disabled="isFieldDisabled"
							@blur="v.name.$touch"
						/>
					</v-col>

					<v-col cols="12">
						<AddressStructuredField
							:value="v.address.$model"
							@change="v.address.$model = $event"
							:v="v.address"
							label="Адрес (место нахождения) организации"
							:global-disabled="isFieldDisabled"
							:notice-recovery="true"
							@blur="v.address.$touch"
							:translationKey="translationKey ? `${translationKey}.addr` : undefined"							
						/>
					</v-col>

					<v-col cols="6">
						<v-text-field
							v-model="v.inn.$model"
							:errorMessages="getValidationErrorText(v.inn)"
							label="ИНН организации"
							outlined
							:disabled="isFieldDisabled"
							@blur="v.inn.$touch"
						/>
					</v-col>

					<v-col cols="4">
						<v-text-field
							v-model="v.phone.$model"
							:errorMessages="getValidationErrorText(v.phone)"
							v-mask="Mask.PHONE"
							label="Контактный телефон"
							outlined
							:disabled="isFieldContactsDisabled"
							@blur="v.phone.$touch"
						/>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {maxLength, minLength, required} from 'vuelidate/lib/validators';
import {getValidationErrorText, EMOJI, TRAILING_AND_LEADING_SPACES} from '@/utils/validate';
import AddressStructuredField, {
	addressValidate,
} from '@/components/base/AddressStructuredField';
import {Mask} from '@/constants';

export const foreignOrganizationModel = {
	name: '',
	address: {},
	inn: '',
	phone: '',
};

export const foreignOrganizationValidation = {
	name: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	address: {
		required,
		...addressValidate(),
		TRAILING_AND_LEADING_SPACES
	},
	inn: {
		required,
		maxLength: maxLength(10),
	},
	phone: {
		required,
		minLength: minLength(16),
	},
};

export default {
	name: 'ForeignOrganization',
	props: {
		v: {
			type: Object,
			required: true,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
			required: true,
		},
		isManual: {
			type: Boolean,
			default: true,
		},
		translationKey: {
      type: String,
    }
	},
	components: {AddressStructuredField},
	data: () => ({
		Mask,
		getValidationErrorText,
	}),
	computed: {
		isFieldDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},

		isFieldContactsDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},
	},
};
</script>
